import react from "../img/project/react.png";
import livewire from "../img/project/livewire.png";
import next from "../img/project/next1.png";
import laravel from "../img/project/laravel1.png";
import react1 from "../img/project/react2.png";
import livewire1 from "../img/project/livewire2.png";
import next1 from "../img/project/nex2.png";
import laravel1 from "../img/project/laravel3.png";
import react2 from "../img/project/react3.png";
import livewire2 from "../img/project/livewire3.png";
import next2 from "../img/project/next4.png";
import laravel2 from "../img/project/laravel4.png";
import case1 from "../img/casestudy1.png";
import case3 from "../img/casestudy2.png";
import case2 from "../img/casestudy3.png";
import caseStudy1 from "../components/Resume/Google-UX-Design-Certifica (5) 2.pptx";
import caseStudy2 from "../components/Resume/Little Lemon.pptx";
import caseStudy3 from "../components/Resume/Soupy Bowls.pptx";
const reactdata = [
  {
    id: 1,
    name: "Description",
    features: [
      {
        id: 1,
        name: "Food Cart",
        description: [
          {
            id: 1,
            point:
              "A food website ui designed in react with tailwind consists menu sections, landing page,seller profile, user profile,and many more other things.Tired to make it full responsive using as much best practices I know with paginations and real time data fetching through axios.As well as some animation through framer motion also used in this.",
          },
        ],
        url: " https://github.com/itiwariarun/Food-Cart",
        imageSrc: react,
        imageAlt: "food cart landing page",
      },
    ],
  },
  {
    id: 2,
    name: "Technologies",
    features: [
      {
        id: 1,
        name: "Technologies/Libraries Used",
        description: [
          {
            id: 1,
            point: " ⦿React",
          },
          {
            id: 2,
            point: "⦿Axios",
          },
          {
            id: 3,
            point: "⦿React-Router",
          },
          {
            id: 4,
            point: "⦿TailwindCss",
          },
          {
            id: 5,
            point: "⦿HTML",
          },
          {
            id: 6,
            point: "⦿JSX/Hooks ",
          },
          {
            id: 7,
            point: "⦿Framer-Motion",
          },
          {
            id: 8,
            point: "⦿HeadlessUi",
          },
        ],
        imageSrc: react1,
        imageAlt: "food cart dahboard",
      },
    ],
  },
  {
    id: 3,
    name: "Included",
    features: [
      {
        id: 1,
        name: "Includes",
        description: [
          {
            id: 1,
            point: "⦿Landing-Page ",
          },
          {
            id: 2,
            point: "⦿Register/Login",
          },
          {
            id: 3,
            point: "⦿Dashboard",
          },
          {
            id: 4,
            point: "⦿Pagination",
          },
          {
            id: 5,
            point: " ⦿Tables",
          },
        ],
        imageSrc: react2,
        imageAlt: "Food cart regiter",
      },
    ],
  },
];
const nextdata = [
  {
    id: 1,
    name: "Description",
    features: [
      {
        id: 1,
        name: "Next.Js blog site",
        description: [
          {
            id: 1,
            point:
              "Next.js blog site with file system data handling, form submission, data fetching through api, consists code of Server Side Rendering, Client Side Rendering, Static Side Generation. Mainly I use static side generation in this.",
          },
        ],
        url: " https://github.com/itiwariarun/Next.js-BLOG",
        imageSrc: next,
        imageAlt: "code blogger landing page",
      },
    ],
  },
  {
    id: 2,
    name: "Technologies",
    features: [
      {
        id: 1,
        name: "Technologies/Libraries Used",
        description: [
          {
            id: 1,
            point: " ⦿Next.js",
          },
          {
            id: 2,
            point: "⦿SSR",
          },
          {
            id: 3,
            point: "⦿TailwindCss",
          },
          {
            id: 4,
            point: "⦿JavaScript",
          },
          {
            id: 5,
            point: " ⦿HTML",
          },
        ],
        imageSrc: next1,
        imageAlt: "code blogger contact page",
      },
    ],
  },
  {
    id: 3,
    name: "Included",
    features: [
      {
        id: 1,
        name: "This Includes",
        description: [
          {
            id: 1,
            point: " ⦿Contact Page ",
          },
          {
            id: 2,
            point: "⦿Signle-BLog-Page",
          },
          {
            id: 3,
            point: "⦿All-Data-Page",
          },
          {
            id: 4,
            point: "⦿Landing-Page",
          },
        ],

        imageSrc: next2,
        imageAlt: "code blogger single blog",
      },
    ],
  },
];
const livewiredata = [
  {
    id: 1,
    name: "Description",
    features: [
      {
        id: 1,
        name: "Livewire Medical website",
        description: [
          {
            id: 1,
            point:
              "Too extensive Livewire medical website consists of consists of too much pages,various types of modals, Forms, Loading Page, ProgressBars, A creative not found page and many other things this is based on tall stack.",
          },
        ],
        url: "https://github.com/itiwariarun/GLH",
        imageSrc: livewire,
        imageAlt: "glh landing page",
      },
    ],
  },
  {
    id: 2,
    name: "Technologies",
    features: [
      {
        id: 1,
        name: "Technologies/Libraries Used",
        description: [
          {
            id: 1,
            point: "⦿Laravel ",
          },
          {
            id: 2,
            point: "⦿Livewire",
          },
          {
            id: 3,
            point: "⦿TailwindCss",
          },
          {
            id: 4,
            point: "⦿Alpine.Js and many other things",
          },
        ],
        imageSrc: livewire1,
        imageAlt: "glh cities modal",
      },
    ],
  },
  {
    id: 3,
    name: "Included",
    features: [
      {
        id: 1,
        name: "Includes",
        description: [
          {
            id: 1,
            point: "⦿Landing Page",
          },
          {
            id: 2,
            point: "⦿Forms",
          },
          {
            id: 3,
            point: "⦿Impressive modals ",
          },
          {
            id: 4,
            point: "⦿Progressive Bars",
          },
          {
            id: 5,
            point: " ⦿Progressive Bars",
          },
          {
            id: 6,
            point: "  ⦿Footers/Headers and many much more pages.",
          },
        ],
        imageSrc: livewire2,
        imageAlt: "glh medical page",
      },
    ],
  },
];
const laraveldata = [
  {
    id: 1,
    name: "Description",
    features: [
      {
        id: 1,
        name: "Blogging Site ",
        description: [
          {
            id: 1,
            point:
              "Blogging website by laravel with blade components method consists of comment system, Authentication with passport and CRUD operation on Posts with responsive ui by tailwind and some custom css.",
          },
        ],
        url: " https://github.com/itiwariarun/Blog",
        imageSrc: laravel,
        imageAlt: "code blog comment-blog page",
      },
    ],
  },
  {
    id: 2,
    name: "Technologies",
    features: [
      {
        id: 1,
        name: "Technologies Used",
        description: [
          {
            id: 1,
            point: "⦿Laravel",
          },
          {
            id: 2,
            point: "⦿Blade files",
          },
          {
            id: 3,
            point: "  ⦿TailwindCss ",
          },
          {
            id: 4,
            point: "⦿Authentication",
          },
          {
            id: 5,
            point: "⦿MySql",
          },
        ],
        imageSrc: laravel1,
        imageAlt: "code blog register",
      },
    ],
  },
  {
    id: 3,
    name: "Included",
    features: [
      {
        id: 1,
        name: "It Includes",
        description: [
          {
            id: 1,
            point: "⦿Landing Pages",
          },
          {
            id: 2,
            point: " ⦿Blade-FIle ",
          },
          {
            id: 3,
            point: "  ⦿Register/Login with Authentication ",
          },
          {
            id: 4,
            point: "   ⦿Commenting System ",
          },
          {
            id: 5,
            point: "   ⦿Post creation/updation",
          },
          {
            id: 6,
            point: "⦿Database Data Fetching ",
          },
          {
            id: 7,
            point: "⦿Dashboard",
          },
        ],
        imageSrc: laravel2,
        imageAlt: "code blog dashboard",
      },
    ],
  },
];
const caseStudies = [
  {
    id: 2,
    name: "Soupy Bowl",
    features: [
      {
        id: 2,
        name: "Soup Bowl Case Study",
        description: [
          {
            id: 1,
            point:
              "Soupy bowl is bakery/cafe app where you can order food, reserve your table and you can also get receipe of any dish provided by cafe and provide your receipe and share your dishes pictures as well.",
          },
        ],
        url: caseStudy3,
        imageSrc: case2,
        imageAlt: "code blog comment-blog page",
      },
    ],
  },
  {
    id: 1,
    name: "Little Lemon",
    features: [
      {
        id: 3,
        name: "Little Lemon Bakery App",
        description: [
          {
            id: 1,
            point:
              "We’re creating a Little Lemon bakery app to attract and retain customers in our online system. We noticed that our competitors offer dedicated mobile apps for their customers to order through, and they have been very successful. We want to create a product that can compete in the market, improve sales, and increase customer satisfaction. ",
          },
        ],
        url: caseStudy2,
        imageSrc: case3,
        imageAlt: "code blog comment-blog page",
      },
    ],
  },
  {
    id: 3,
    name: "Mid Snack",
    features: [
      {
        id: 1,
        name: "Mid Snack Case Study",
        description: [
          {
            id: 1,
            point:
              "Mid snack is mid-movie snack buying flow for a modern movie theatre. THe typical user is between 18-40 years old, and most users are college students of career profersionals. Mid snackgoal is to make users not to wait users in queue for food.",
          },
        ],
        url: caseStudy1,
        imageSrc: case1,
        imageAlt: "code blog comment-blog page",
      },
    ],
  },
];
export { reactdata, nextdata, livewiredata, laraveldata, caseStudies };
